package br.com.texeratx.boardgametimeapp.data.model.login

import kotlinx.serialization.Serializable

@Serializable
data class SignupRequest(
    val email: String,
    val password: String,
    val displayName: String
)
